import React from "react";

/**
 * ErrorBoundary — global safety net so operators never see a blank
 * white page when a React tree throws during render.  STD-009 §5
 * compliance (recovery affordance).
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Uncaught render error", error, info);
  }
  reset = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.reload();
  };
  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="error-boundary"
          className="mx-auto max-w-lg space-y-4 py-10 text-center"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-rose-100 text-rose-700 text-2xl">
            !
          </div>
          <h1 className="font-display text-xl font-semibold text-ink-primary">
            Something went wrong loading this page.
          </h1>
          <p className="text-sm text-ink-secondary">
            The application encountered an unexpected error. This has been
            logged. You can retry or return to the Operations Command Center.
          </p>
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={this.reset}
              data-testid="error-boundary-retry"
              className="rounded-md bg-brand px-4 py-2 text-sm font-semibold text-brand-foreground hover:bg-brand-hover"
            >
              Retry
            </button>
            <a
              href="/ops"
              data-testid="error-boundary-home"
              className="rounded-md border border-divider bg-surface px-4 py-2 text-sm text-ink-primary hover:bg-surface-alt"
            >
              Operations Command Center
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
